export default __webpack_public_path__ + "static/media/Abyssal Cloak of Crimson Slaughter.68951087.jpg";